import { GeneralConditionEntity } from './GeneralConditionEntity';

export class VendorBuyingAgreementGeneralConditionEntity extends GeneralConditionEntity {
  constructor(entity?: VendorBuyingAgreementGeneralConditionEntity) {
    super(entity);
  }
}
